module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPc ? 'signin' : ''
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'qrcode'
    }
  }), _vm._v(" "), _c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Inputs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.passwordShow),
      expression: "!passwordShow"
    }],
    attrs: {
      "type": 'account',
      "data": _vm.account
    },
    on: {
      "inputText": _vm.getAccount,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('el-collapse-transition', [(_vm.notExist) ? _c('Warn', {
    attrs: {
      "type": 'accountnotexist',
      "data": _vm.account
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Account', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordShow),
      expression: "passwordShow"
    }],
    staticStyle: {
      "margin-top": "38px"
    },
    attrs: {
      "content": _vm.account
    },
    on: {
      "showPassword": _vm.showPassword
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "password-input",
    style: ({
      marginTop: (!_vm.passwordShow ? '-70px' : '0'),
      opacity: (!_vm.passwordShow ? '0' : '1')
    })
  }, [_c('Inputs', {
    attrs: {
      "type": 'password',
      "remember": {
        password: _vm.password,
        rememberpw: _vm.rememberpw
      },
      "change": _vm.change
    },
    on: {
      "inputText": _vm.getPassword,
      "rememberpw": _vm.getRememberpw,
      "enterInput": _vm.enterInput
    }
  })], 1), _vm._v(" "), (!_vm.passwordShow) ? _c('Buttons', {
    ref: "btn",
    attrs: {
      "type": 'signin',
      "data": _vm.account
    },
    on: {
      "accountNotExist": _vm.accountNotExist,
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip,
      "showPassword": _vm.showPassword
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordShow) ? _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "margin-top": "60px"
    },
    style: ({
      marginBottom: (!_vm.isEmail && !_vm.isPhone ? '80px' : '')
    }),
    attrs: {
      "type": 'login',
      "data": {
        type: _vm.type,
        password: _vm.password,
        account: _vm.account
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip,
      "loginSuccess": _vm.loginSuccess
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.passwordShow) ? _c('Foot', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "type": 'No using crait'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordShow && (_vm.isEmail || _vm.isPhone)) ? _c('Foot', {
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "44px"
    },
    attrs: {
      "type": 'Forgot password',
      "isEmail": _vm.isEmail ? true : false,
      "account": _vm.account
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a29d3a38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/login/Signin.vue
// module id = 745
// module chunks = 1